import React, { useContext, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
//import { CheckboxTable } from "../../view/CheckboxTable";
import { CheckboxBaselineTable } from "../../view/CheckboxBaselineTable";
import { useMsbTableHelper } from "./useMsbTableHelper";
import MsbTableRow from "./MsbTableRow";
import MsbTableRowSkeleton from "./MsbTableRowSkeleton";
import { TableContext } from "../../index";
import ValidateHeaderMenuItem from "../validate/ValidateHeaderMenuItem";

function MsbTable({ rules = [] }) {

    const helper = useMsbTableHelper();
    const { config } = useContext(TableContext);

    const dataColumns = [
        { name: 'RULE', state: true, sortKey: 'name', onClick: () => helper.onRuleClick() },
        { name: 'SECTION', state: false, sortKey: 'sectionName', onClick: () => helper.onSectionClick() },
        { name: 'SUBSECTION', state: false, sortKey: 'subsectionName', onClick: () => helper.onSubsectionClick() },
        { name: 'MODIFIED', state: true, sortKey: 'baseRule', onClick: () => helper.onModifiedClick() },
        { name: 'CREATED ON', state: true, sortKey: 'createdOn', onClick: () => helper.onCreatedOnClick() },
        { name: 'MODIFIED ON', state: true, sortKey: 'updatedOn', onClick: () => helper.onModifiedOnClick() },
        { name: 'CREATED BY', state: true, sortKey: 'user', onClick: () => helper.onUserClick() },
        { name: 'SEVERITY', state: true, sortKey: 'severity', onClick: () => helper.onSeverityClick() },
    ]

    const [hiddenHeaders, setHiddenHeaders] = useState(
        dataColumns.filter(column => column.state !== true).map(column => column.name)
    );
    const [updatedColumns, setUpdatedColumns] = useState(dataColumns);

    const columnMenu = [{
        name: <ValidateHeaderMenuItem
            updatedHiddenHeaders={hiddenHeaders}
            sendHiddenHeaders={(nextHiddenHeaders) => setHiddenHeaders([...nextHiddenHeaders])}
            dataColumns={updatedColumns}
            sendUpdatedDataColumns={(nextColumns) => setUpdatedColumns(nextColumns)}
        />,
        className: "oct_table-actions-cell-v2"
    }];

    const headers = [
        ...updatedColumns.filter(column => column.state === true),
        ...columnMenu
    ];

    return (
        <>
            <CheckboxBaselineTable headers={headers} elements={rules} containsEditButton={false}>
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <MsbTableRowSkeleton key={index} index={index} hiddenHeaders={hiddenHeaders} />
                    ))
                ) : (
                    rules.map((data, index) => <MsbTableRow key={index} configPath={helper.configPath} data={data}
                        index={index} hiddenHeaders={hiddenHeaders} />)
                )}
            </CheckboxBaselineTable>
            {!config.isLoading && rules.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );

}


function mapStateToProps(state) {
    debug("MsbTable mapStateToProps", state);
    const msbPage = state.msbPage;
    return { rules: msbPage.rules || [] };
}

export default connect(mapStateToProps)(MsbTable)
